import React, {useState,useEffect} from 'react'
import {Input, Table, Select, Inputs, useFormValidator, FormValidator, createDialog} from 'coaz-ui';
import client from '../client';
import AddUsersResultsTable from './AddUsersResultsTable';


  const AddUsersTable = ({params, submitRef, setLoading, setEnableSubmit}) => {
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [userType,setUserType] = useState(null);
    const [userGroup,setUserGroup] = useState(null);
    const [userTypes,setUserTypes] = useState([]);
    const [userGroups,setUserGroups] = useState([]);
    const {request,errorMessage} = client;
    const columns = [
        {
            id:'username',
            name:'username',
            label:'Username'
        },
        {
            id:'firstname',
            name:'firstname',
            label:'Firstname'
        },
        {
            id:'lastname',
            name:'lastname',
            label:'Lastname'
        },
        {
            id:'middlename',
            name:'middlename',
            label:'Middlename'
        },
        {
            id:'sex',
            name:'sex',
            label:'Sex'
        },
        {
            id:'dateOfBirth',
            name:'dateOfBirth',
            label:'Date of Birth'
        },
        {
            id:'idType',
            name:'idType',
            label:'ID Type'
        },
        {
            id:'idNumber',
            name:'idNumber',
            label:'ID Number'
        },
        {
            id:'nationality',
            name:'nationality',
            label:'Nationality'
        },
        {
            id:'email',
            name:'email',
            label:'Email'
        },
        {
            id:'phone1',
            name:'phone1',
            label:'Phone 1'
        },
        {
            id:'phone2',
            name:'phone2',
            label:'Phone 2'
        },
        {
            id:'physicalAddress',
            name:'physicalAddress',
            label:'Physical Address'
        },
        {
            id:'postalAddress',
            name:'postalAddress',
            label:'PostalAddress'
        },
        {
            id:'district',
            name:['district','name'],
            label:'District'
        },
        {
            id:'program',
            name:'program',
            label:'Program'
        },
        {
            id:'institution',
            name:'institution',
            label:'Institution'
        },
        {
            id:'professionalCategory',
            name:'professionalCategory',
            label:'Professional Category'
        },
        {
            id:'employed',
            name:'employed',
            label:'Employed'
        },
        {
            id:'employer',
            name:'employer',
            label:'Employer'
        },
        {
            id:'employeeId',
            name:'employeeId',
            label:'Employee Id'
        },
        {
            id:'organizationalUnit',
            name:'organizationalUnit',
            label:'Organizational Unit'
        },
        {
            id:'currentPosition',
            name:'currentPosition',
            label:'Current Position'
        },
        {
            id:'facility',
            name:'facility',
            label:'Facility'
        },
        {
            id:'status',
            name:'status',
            label:'Status'
        }
    ]

    const getUsers = async (filter,page) => {
        if(params && params.pages && page && page.pageNo < params.pages.length) {
            let totalElements = (()=>{
                    let count = 0;
                    for(let pg of params.pages) {
                        count += pg.length;
                    }
                    return count;
                })();
            let totalPages = Math.ceil(totalElements/page.pageSize);
            return {
                status:'SUCCESSFUL',
                content:params.pages[page.pageNo],
                pageNo:page.pageNo,
                pageSize:page.pageSize,
                totalElements:totalElements,
                totalPages:totalPages,
                last:page.pageNo >= totalPages
            }
        }
    }

    const onSubmit = async  () => {
        if(password !== confirmPassword) {
            return {
                message: errorMessage("Password and confirm password don't match")
            };
        }
        let users = [];
        for(let page of params.pages) {
            for(let user of page) {
                users.push(user);
            }
        }

        try {
            const response = await request('POST','users/all',{
                auditables:users,
                password:password,
                userTypeId:userType.ref.id,
                userGroupId:userGroup?userGroup.ref.id:null
            });

            if (response) {
                createDialog({
                    title:"Add Users",
                    Component:AddUsersResultsTable,
                    params:{results:response.invalid?response.invalid:[]}
                })
                return {
                    message: 'Successful',
                    success: true
                };
            }

            return {
                message: errorMessage(response)
            };
        } catch (error) {
            return {
                message: errorMessage(error)
            };
        }
    }

    const [register,handleChange,handleSubmit,errors] = useFormValidator(onSubmit);

    const inputWidth = 320;

    const inputs = [
        {
            label:'User Type',
            type:'select',
            options:() => {
                let options = [];
                userTypes.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'userType', 
            value:userType?userType.ref.id:'',
            onChange:(e) => handleChange(e,(e) => {
                let value = userTypes.find((type) => {return type.ref.id == e.target.value})
                setUserType(value?value:null);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'User Group',
            type:'select',
            options:() => {
                let options = [<option value=''>None</option>];
                userGroups.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'userGroup', 
            value:userGroup?userGroup.ref.id:'',
            onChange:(e) => handleChange(e,e => {
                let value = userGroups.find((group) => {return group.ref.id == e.target.value})
                setUserGroup(value?value:null);
            })
        },
        {
            label:'Password',
            type:'password',
            name:'password', 
            value:password?password:'',
            placeholder:'Enter password...',
            onChange:(e) => handleChange(e,e => {
                setPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Confirm Password',
            type:'password',
            name:'confirmPassword', 
            value:confirmPassword?confirmPassword:'',
            placeholder:'Confirm password...',
            onChange:(e) => handleChange(e,e => {
                setConfirmPassword(e.target.value);
            }),
            register:register,
            checks:['empty'],
            errors:errors
        }
    ]

    useEffect(() => {
        if (handleSubmit) {
            submitRef.current = { submit: handleSubmit };
            setEnableSubmit(true);
        } else {
            submitRef.current = null;
            setEnableSubmit(false);
        }

        return () => {
            submitRef.current = null;
        };
    }, [handleSubmit]);

    useEffect(() => {
        ( async () => {
            setLoading(true);
            await request('GET','usertypes')
            .then((response) => {
                setLoading(false);
                if(response && response.length > 0) {
                    let types = response.filter((type => !type.reserved));
                    if(types && types.length > 0) {
                        setUserTypes(types);
                        setUserType(types[0])
                    } else {
                        setUserTypes([]);
                    }
                }  else {
                    setUserTypes([]);
                }
            })
            .catch((error) => {
                console.log(error.message);
                setUserTypes([]);
            })
            await request('GET','usergroups',null,null,false)
            .then((response) => {
                setLoading(false);
                if(response) {
                    setUserGroups(response);
                }  else {
                    setUserGroups([]);
                }
            })
            .catch((error) => {
                console.log(error.message);
                setUserGroups([]);
            })
        }
        )();
    },[]);

    return (
        <FormValidator>
            <div className='relative flex flex-col w-full h-full'>
                <Table columns={columns} retrieveRecords={getUsers}/>
                <Inputs inputs={inputs} minWidth={240} id={'add_users'} onSubmit={handleSubmit}/>
            </div>
        </FormValidator>
    )
}

export default AddUsersTable

